import { useEffect, useState } from 'react';
import s from './PageLoader.module.scss';

// 전 페이지 공통 진입 로더(2026-09-08 사용자 표준 [[evs-page-ux-standards]]).
//   네이비 오버레이 + 시안 회전 링. 짧게(≈650ms) 보인 뒤 페이드아웃(노드 유지, pointer 통과).
//   뉴스 상세는 자체 로더(히어로 이미지 로드 연동) 유지 — 그 외 페이지에서 이 공용 로더 사용.
export default function PageLoader() {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setDone(true), 650);
    return () => window.clearTimeout(t);
  }, []);
  return (
    <div className={`${s.loader} ${done ? s.done : ''}`} aria-hidden="true">
      <span className={s.ring} />
      <span className={s.brand}>EVS</span>
    </div>
  );
}
